document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.music-source-only').forEach(function (container) {
    const player = container.querySelector('.wp-block-audio audio');
    if (!player) return;

    container.querySelectorAll('a').forEach( (link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const audioSrc = this.href;
        player.src = audioSrc;
        player.load();
        player.play();
      });
    });
  });


  document.querySelectorAll('.video-source-only').forEach(function (container) {
    const player = container.querySelector('iframe');
    if (!player) return;

    container.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const videoSrc = this.href;
        player.src = videoSrc;
        player.load();
        player.play();
      });
    });
  });

});

